<template>
  <Modal
    v-if="dialog"
    :dialog.sync="dialog"
    title="Информация по синхронизации"
    contentClass="esh-theme adminModal"
    fullscreen
    actionsBottom
  >
    <template #body>
      <Table
        :headers="headers"
        :items="task.stages"
        item-key="id"
        class="elevation-1"
      >
        <template v-slot:item.created_at="{ item }">
          {{ item.created_at | dateTime }}
        </template>
        <template v-slot:item.updated_at="{ item }">
          <span v-if="['complete', 'error'].includes(item.state)">{{
            item.updated_at | dateTime
          }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <span v-if="item.name">{{
            BASE.LOG_TASK_CHOICES[item.name.toUpperCase()] || "-"
          }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:item.state="{ item }">
          <span v-if="item.state">{{
            BASE.TASK_STATE_CHOICES[item.state.toUpperCase()] || "-"
          }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:item.progress="{ item }">
          <div class="progress">
            <v-progress-linear
              v-if="item.state === 'processing' && item.progress === 0"
              indeterminate
              style="position: absolute; bottom: 0px"
              height="1"
            ></v-progress-linear>
            <div class="progress-info">
              <span v-if="item.state === 'error'">
                <v-icon color="white">mdi-close</v-icon>
              </span>
              <span v-else-if="item.state === 'complete'">
                <v-icon color="white">mdi-check</v-icon>
              </span>
              <span v-else>{{ item.progress }}%</span>
            </div>
            <div
              class="progress-loading"
              :style="`width: ${
                item.state === 'processing' ? item.progress : '100'
              }%`"
              :class="{
                'progress-loading_done': item.state === 'complete',
                'progress-loading_failed': item.state === 'error',
              }"
            ></div>
          </div>
        </template>
      </Table>
    </template>
    <template #actions>
      <v-row align="center" justify="end" no-gutters>
        <v-btn icon x-small v-if="!['complete'].includes(task.state)">
          <v-icon @click="$emit('update:status', task)">mdi-update</v-icon>
        </v-btn>
        <v-btn icon x-small v-if="!['complete'].includes(task.state)">
          <v-icon color="red" @click="$emit('update:cancel', task)"
            >mdi-cancel</v-icon
          >
        </v-btn>
        <v-btn icon x-small>
          <v-icon color="red" @click="$emit('update:delete', task)"
            >mdi-delete</v-icon
          >
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('update:dialog', false)">Закрыть</v-btn>
      </v-row>
    </template>
  </Modal>
</template>

<script>
import { Modal } from "@/components/common";
import { Table } from "@/components/common";
import { BASE } from "@/config/index";

export default {
  name: "InfoSyncModal",
  components: {
    Modal,
    Table,
  },
  props: {
    show: {
      props: Boolean,
      default: false,
    },
    task: {
      props: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      BASE,
      rules: {
        required: (value) => !!value || "Заполните обязательно!",
        positiveInt: (value) =>
          /^\+?([1-9]\d*)$/.test(value) ||
          "Значение должно быть целым положительным числом",
      },
      headers: [
        { text: "#", value: "id" },
        { text: "Дата создания (начало)", value: "created_at" },
        { text: "Дата обновления (завершена)", value: "updated_at" },
        { text: "Наименование", value: "name" },
        { text: "Детали", value: "details" },
        { text: "Состояние", value: "state" },
        { text: "Прогресс", value: "progress" },
      ],
    };
  },
  computed: {
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
};
</script>

<style scoped>
.progress {
  position: relative !important;
  height: 100%;
  margin: 0px -16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.progress-info {
  color: #000;
  position: relative;
  z-index: 2;
}
.progress-loading {
  transition: all 0.3s ease;
  background-color: #64b5f6;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: block;
}
.progress-loading_done {
  background-color: #aed581;
}
.progress-loading_failed {
  background-color: #e57373;
}
</style>
